module.exports = __webpack_public_path__ + "img/art.24d1f18a.png";